import { formatTemplate } from '../utils/handlebars'
import { get, debounce } from 'lodash'

export default {
  computed: {
    title() {
      return get(this.map, 'title', null)
    },
    subTitle() {
      return get(this.map, 'subTitle', null)
    },
    description() {
      return get(this.map, 'description', null)
    }
  },
  methods: {
    handleFilterChange() {
      this.gridAPI.setCacheBlockSize(this.cacheBlockSize)
    },

    saveGridColumnState: debounce(function(e) {
      if (this.map.saveColumnState && e.source !== 'api') {
        const columnState = e.columnApi.getColumnState()
        localStorage.setItem(`ag_grid_${this.map.identifier}`, JSON.stringify(columnState))
      }
    }, 500),

    async onGridReady(params) {
      this.gridAPI = params.api
      if (this.map.saveColumnState) {
        const getGridState = localStorage.getItem(`ag_grid_${this.map.identifier}`)
        if (getGridState && getGridState.length) {
          params.columnApi.applyColumnState({ state: JSON.parse(getGridState), applyOrder: true })
        }
      }

      this.gridAPI.sizeColumnsToFit()
      this.gridAPI.showLoadingOverlay()
      const preQueryResults = await this.handlePreQueries()
      this.handleColumnFilters({ preQuery: preQueryResults, global: this.map.context })

      if (this.map.noRowsMessage) {
        this.overlayNoRowsTemplate = this.map.noRowsMessage
      }

      return params.api.setServerSideDatasource({
        getRows: (p) => {
          this.getData(p)
        }
      })
    },

    handleColumnFilters(cellRendererContext) {
      this.columnDefs.forEach((col, idx) => {
        this.columnDefs[idx].cellRendererParams = cellRendererContext
        if (col.filterValuesPath) {
          const filterLabel = col.filterLabel
          const filterValue = col.filterValue
          const filterExcludeValues = col.filterExcludeValues || []
          let pathValues = get(cellRendererContext, col.filterValuesPath)

          if (pathValues) {
            const filterParams = {
              ...col.filterParams,
              values: pathValues
            }

            if (filterLabel && filterValue && Array.isArray(pathValues)) {
              pathValues = pathValues.reduce((acc, cur) => {
                acc[cur[filterValue]] = cur[filterLabel]
                return acc
              }, {})
            }

            if (pathValues && typeof pathValues === 'object') {
              filterParams.values = Object.keys(pathValues).filter(item => !filterExcludeValues.includes(item))
              filterParams['valueFormatter'] = (params) => {
                const value = params.value
                return pathValues[value] || value
              }
            }

            this.columnDefs.splice(idx, 1, {
              ...col,
              filterParams
            })
          }
        }
      })
    },

    clearFilters() {
      this.gridOptions.api.setFilterModel(null)
      this.gridOptions.api.onFilterChanged()
    },

    handleCellRenderer(params) {
      if (this.map.fetchStrategy.loadMessage && this.map.fetchStrategy.loadMessage.length) {
        const message = formatTemplate(this.map.fetchStrategy.loadMessage, {
          start: params.rowIndex,
          limit: this.map.fetchStrategy.limit,
          total: this.rowCount
        })

        return {
          component: 'loadingCellRenderer',
          params: {
            loadingMessage: message
          }
        }
      }
      else {
        return undefined
      }
    }
  }
}
